import React from 'react';
import { useLocale } from '../../context/LocaleContext';

export default function UserProfileCard({ displayName, email, initial, onLogout }) {
  const { t } = useLocale();
  return (
    <div className="custio-user-card">
      <div className="custio-user-card__inner">
        <div className="custio-user-card__avatar" aria-hidden>
          {initial}
        </div>
        <div className="custio-user-card__info">
          <div className="custio-user-card__name">{displayName}</div>
          <div className="custio-user-card__email" title={email}>
            {email}
          </div>
        </div>
      </div>
      <button type="button" className="custio-user-card__logout" onClick={onLogout}>
        {t('shell.logOut')}
      </button>
    </div>
  );
}
